/* oxlint-disable @fullscript/gql-file-usage */
// REASON: pre-existing operation file, to be migrated to a .gql file in a follow up MR
import { gql } from "@apollo/client";

const UserRolesType_Shared_Query = gql`
  query UserRolesType_Shared_Query {
    viewer {
      user {
        id
        roles {
          id
          type
        }
      }
    }
  }
`;

export { UserRolesType_Shared_Query };
